import React, { useState } from 'react';
import { PasswordInput } from '../../../components/input'

import {
	Alert,
	Button,
	Col,
	Form,
	FormGroup,
	Label,
	Row,
} from 'reactstrap';
import ResetPasswordInstructions from './resetPasswordInstructions';

interface Response {
	succeeded: boolean,
	errors: any[],
}

interface PasswordConfig {
	requireDigit: boolean,
	requiredLength: number,
	requireNonAlphanumeric: boolean,
	requireUppercase: boolean,
	requireLowercase: boolean,
	historyCount: number,
	maxLength: number,
}

function ChangePassword(props: any) {

	const {
		onSubmit,
		onCancel,
		showCancel,
		response,
		passwordConfig,
		isFirstLogin
	}: {
		onSubmit: Function,
		onCancel?: Function,
		showCancel?: boolean,
		response: Response,
		passwordConfig: PasswordConfig,
		isFirstLogin: boolean
	} = props;

	const [currentPassword, setCurrentPassword] = useState<string>('');
	const [newPassword, setNewPassword] = useState<string>('');
	const [confirmPassword, setConfirmPassword] = useState<string>('');
	const [isCurrentNotProvided, setIsCurrentNotProvided] = useState<boolean>(false);
	const [isNotLongEnough, setIsNotLongEnough] = useState<boolean>(false);
	const [isSameAsCurrent, setIsSameAsCurrent] = useState<boolean>(false);
	const [isNotConfirmed, setIsNotConfirmed] = useState<boolean>(false);

	const handleSubmit = (event: any) => {
		event.preventDefault();
		var fieldsValid = validatePasswords();
		if (fieldsValid) {
			onSubmit(currentPassword, newPassword, confirmPassword)
		}
	}

	const handleCancel = (event: any) => {
		event.preventDefault();

		setCurrentPassword('');
		setNewPassword('');
		setConfirmPassword('');

		if (onCancel) {
			onCancel();
		}
	}

	const validatePasswords = () => {
		return (
			validateField("currentPassword", currentPassword) &&
			validateField("newPassword", newPassword) &&
			validateField("confirmPassword", confirmPassword)
		);
	}

	const validateField = (field: string, value: string) => {
		switch (field) {

			case "currentPassword":
				let isCurrentProvided = !!value;
				setIsCurrentNotProvided(!isCurrentProvided);
				return isCurrentProvided;

			case "newPassword":
				let isNotLongEnough = !value || value.length < passwordConfig.requiredLength;
				let isSameAsCurrent = value === currentPassword;
				setIsNotLongEnough(isNotLongEnough);
				setIsSameAsCurrent(isSameAsCurrent);
				return !(isNotLongEnough || isSameAsCurrent);

			case "confirmPassword":
				let isConfirmed = newPassword === confirmPassword;
				setIsNotConfirmed(!isConfirmed);
				return isConfirmed;

			default:
				return true;
		}
	}

	const checkString = (source: string, subString: string) => {
		var ret = false;
		var index = -1;

		index = source.indexOf(subString);
		if (index > -1) {
			ret = true;
		}
		return ret;
	}

	const handleChange = (event: any) => {
		const { name, value } = event.target;

		switch (name) {
			case "currentPassword":
				setCurrentPassword(value);
				return;

			case "newPassword":
				setNewPassword(value);
				return;

			case "confirmPassword":
				setConfirmPassword(value);
				return;

			default:
				return;
		}
	}

	const isCurrentNotProvidedStyle = {
		display: isCurrentNotProvided ? "block" : "none",
	}

	const isNotLongEnoughStyle = {
		display: isNotLongEnough ? "block" : "none",
	}

	const isSameAsCurrentStyle = {
		display: isSameAsCurrent ? "block" : "none",
	}

	const isNotConfirmedStyle = {
		display: isNotConfirmed ? "block" : "none",
	}

	const successStyle = {
		width: '100%',
		textAlign: 'center' as 'center',
	}

	const errorStyle = {
		width: '100%',
	}

	return (
		<Form onSubmit={handleSubmit} className="changePasswordForm">
			<Row>
				<Col lg={"12"}>
					<ResetPasswordInstructions />
				</Col>
			</Row>
			<Row>
				<Col className="d-flex justify-content-center">
					{response && response.errors.length > 0 ?
						<Alert color="danger" style={errorStyle}>
							<ul>
								{response.errors.map((e, i) => {
									return (
										<li key={i}>
											<div className="invalid-feedback" style={{ display: "inline" }}>{e}</div>
										</li>
									)
								})}
							</ul>
						</Alert>
						: response && response.succeeded ?
							<Alert color="success" style={successStyle}>Your password has been changed successfully.</Alert>
							: ''}
				</Col>
			</Row>
			<Row>
				<Col lg={isFirstLogin ? "12" : "3"}>
					<FormGroup>
						<Label for="currentPassword" className="fw-bold">CURRENT PASSWORD</Label>
						<PasswordInput label="Password" name="currentPassword" id="currentPassword"
							onChange={handleChange} value={currentPassword} />
						<div className="invalid-feedback" style={isCurrentNotProvidedStyle}>You must provide your current password.</div>
					</FormGroup>
				</Col>
			</Row>
			<Row>
				<Col lg={isFirstLogin ? "12" : "3"}>
					<FormGroup>
						<Label for="newPassword" className="fw-bold">NEW PASSWORD</Label>
						<PasswordInput label="New Password" name="newPassword" id="newPassword"
							onChange={handleChange} value={newPassword} />
						<div className="invalid-feedback" style={isNotLongEnoughStyle}>Your new password must be at least {passwordConfig.requiredLength} characters.</div>
						<div className="invalid-feedback" style={isSameAsCurrentStyle}>Your new password can't match your current one.</div>

					</FormGroup>
				</Col>
				<Col lg={isFirstLogin ? "12" : "3"}>
					<FormGroup>
						<Label for="confirmPassword" className="fw-bold">CONFIRM PASSWORD</Label>
						<PasswordInput label="Confirm Password" name="confirmPassword" id="confirmPassword"
							onChange={handleChange} value={confirmPassword} />
						<div className="invalid-feedback" style={isNotConfirmedStyle}>You must confirm your new password.</div>
					</FormGroup>
				</Col>
			</Row>
			<Row>
				<Col lg={isFirstLogin ? "12" : "3"}>
					<Button type="submit" color="primary" block={isFirstLogin ? true : false} style={isFirstLogin ? { marginBottom: "16px" } : { marginRight: '10px' }}>Save</Button>
					{showCancel &&
						<Button onClick={handleCancel} block={isFirstLogin ? true : false} style={isFirstLogin ? { marginBottom: "16px" } : { marginRight: '10px' }}>Cancel</Button>
					}
				</Col>
			</Row>
		</Form>
	)
	
}

export default ChangePassword;
